// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Fmt4H","col":"styles_col__1YDZ7"};